<template>
  <div>
    <PageAllow controller="ShopCostAnalyze" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="overflow-y-scroll fill-content-height">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-spacer />
            <!-- 批量导出 -->
            <v-btn
              small
              color="print"
              dark
              class="ms-1"
              @click.stop="exportExcel()"
              v-if="$permission.permissionAllow('ShopCostAnalyze', 'export')"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("ShopCostAnalyze.Export.batchExports") }}
            </v-btn>
            <v-btn
              small
              color="primary"
              dark
              class="ms-1"
              @click.stop="
                $router.push('/shop-cost-analyze/detail/push-to-shop')
              "
              v-if="
                $permission.permissionAllow(
                  'ShopCostAnalyze',
                  'addShopCostAnalyze'
                )
              "
            >
              {{ $t("ShopCostAnalyze.addShopCostAnalyze") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels :value="[1]" multiple flat accordion mandatory>
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherShops
                  v-model="shopsSelected"
                  psi_enable
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="cost_analyzes"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.cost_analyze_code="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.cost_analyze_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.business_date="{ item }">
            {{ item.business_start_date | formatTime }}-{{
              item.business_end_date | formatTime
            }}
          </template>
          <template v-slot:item.shop_name="{ item }">
            {{
              $t("ShopCostMonthlyAnalyze.shopNameWithStandard", [
                item.shop_name,
                item.shop_code,
              ])
            }}
          </template>

          <template v-slot:item.sale_volume="{ item }"
            >{{ $t("Global.money") }}
            {{ item.sale_volume | formatMoney }}</template
          >
          <template v-slot:item.actual_sale_volume="{ item }"
            >{{ $t("Global.money") }}
            {{ item.actual_sale_volume | formatMoney }}</template
          >
          <template v-slot:item.theory_price="{ item }"
            >{{ $t("Global.money") }}
            {{ item.theory_price | formatMoney }}</template
          >
          <template v-slot:item.actual_price="{ item }"
            >{{ $t("Global.money") }}
            {{ item.actual_price | formatMoney }}</template
          >
          <template v-slot:item.loss_price="{ item }"
            >{{ $t("Global.money") }}
            {{
              (item.actual_price - item.theory_price) | formatMoney
            }}</template
          >
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="$permission.permissionAllow('ShopCostAnalyze', 'view')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="secondary"
                  class="px-1 py-4 me-1"
                  @click="$router.push('/shop-cost-analyze/' + item.id)"
                  >fa-file-alt
                </v-icon>
              </template>
              <span>{{ $t("shopDailyReports.viewInfo") }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('ShopCostAnalyze', 'exportDetail')
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="print"
                  class="px-1 py-4 me-1"
                  @click="detailExports(item.id)"
                  >fa-file-excel
                </v-icon>
              </template>
              <span>{{ $t("ShopCostAnalyze.Export.excel") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import SearcherShops from "@/components/plugins/SearcherShops";
import shopCostAnalyze from "@/api/shop_cost_analyze";
// import { ValidationObserver, ValidationProvider } from "vee-validate";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  business_time_from: "",
  business_time_to: "",
  shop_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,

    SearcherShops,
    SearcherDatetimeRangeWithRadio,
    // ValidationObserver,
    // ValidationProvider,
  },
  mounted() {
    // this.$store.commit("districtID", 0);
    this.$store.commit("searchDistrict", false);
    this.$commonUtils
      .loadOptions("ShopCostMonthlyAnalyze", ["shopsSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    shopsSelected: [],
    cost_analyzes: [],
    paging: {},
  }),
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.shopCostAnalyze", [this.$consts.shopName()]),
          disabled: true,
        },
      ];
    },
    headers() {
      var headers = [
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.cost_analyze_code"),
          align: "start",
          sortable: false,
          value: "cost_analyze_code",
        },
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.business_date"),
          align: "start",
          sortable: false,
          value: "business_date",
        },
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.shop_name", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.sale_volume"),
          align: "start",
          sortable: false,
          value: "sale_volume",
        },
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.actual_sale_volume"),
          align: "start",
          sortable: false,
          value: "actual_sale_volume",
        },
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.theory_price"),
          align: "start",
          sortable: false,
          value: "theory_price",
        },
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.actual_price"),
          align: "start",
          sortable: false,
          value: "actual_price",
        },
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.loss_price"),
          align: "start",
          sortable: false,
          value: "loss_price",
        },
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
      return headers;
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("ShopCostMonthlyAnalyze.created_time"),
      },
      {
        key: "business",
        text: i18n.t("ShopCostMonthlyAnalyze.business_time"),
      },
    ],
    ...mapState(["settings", "loading"]),
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.shopsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getCostAnalyzesFromAPI() {
      shopCostAnalyze.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.cost_analyzes = response.data.cost_analyzes;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    exportExcel() {
      shopCostAnalyze.batchDetailExports(this.options);
    },
    detailExports(id) {
      shopCostAnalyze.detailExports(id);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getCostAnalyzesFromAPI();
        sessionStorage.setItem(
          "ShopCostMonthlyAnalyze-options",
          JSON.stringify(this.options)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : [];
        sessionStorage.setItem(
          "ShopCostMonthlyAnalyze-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
  },
};
</script>
